// ThemedText.jsx - Reusable text component for theme-based color classes
import React from "react";

const ThemedText = ({
  theme,
  children,
  baseClass = "",
  pinkClass = "text-pink-primary-600",
  blueClass = "text-blue-900",
}) => {
  const colorClass =
    theme === "pink" ? pinkClass : blueClass;

  return <span className={`${baseClass} ${colorClass}`}>{children}</span>;
};

export default ThemedText;